import { render, staticRenderFns } from "./CustomTargetingListTable.vue?vue&type=template&id=2b981154"
import script from "./CustomTargetingListTable.vue?vue&type=script&lang=js"
export * from "./CustomTargetingListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports